module.exports = __webpack_public_path__ + "img/settle-inbounds.aaed7b24.png";